/**
 * Expiring the identifiers an advertising or analytics script wrote (ui#256, ui#834, kitecorp/transferify#375) —
 * React-free.
 *
 * One copy for the Google tag, the Reddit pixel and the Meta pixel. Each of them used to carry this loop
 * verbatim, and a fix to one (a cookie that survived on a parent domain) would have reached only the copy
 * it was made in.
 *
 * Matched by a NAME PATTERN rather than by a list of names, because the names are a fact about somebody
 * else's script and a list would go stale without anything noticing: a cookie the script starts writing
 * next month is removed too.
 *
 * Expiry is attempted on the host and on each parent domain, because these scripts write on the
 * registrable domain while this app may run on a subdomain (`dev.transferify.ro`, a claimed tenant host),
 * so expiring only the exact host would leave the real cookie in place and look successful.
 */
export function expireCookiesMatching(document: Document, pattern: RegExp): void {
	const names = document.cookie
		.split(";")
		.map((entry) => entry.split("=")[0]?.trim() ?? "")
		.filter((name) => pattern.test(name));
	const labels = document.location.hostname.split(".");
	const domains = labels
		.map((_, index) => labels.slice(index).join("."))
		.filter((domain) => domain.includes("."));
	names.forEach((name) => {
		document.cookie = `${name}=; Max-Age=0; path=/`;
		domains.forEach((domain) => {
			document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
			document.cookie = `${name}=; Max-Age=0; path=/; domain=.${domain}`;
		});
	});
}
